import React, { Component } from 'react';
import { properties } from '../properties.js';
import Web3 from 'web3';
import standard_abiA from '../../abis/DPP-abi.json';
import Navbar from "../LogInNavBar.js";
import Footer from "../Footer.js";
import { withTranslation } from 'react-i18next';
import './css_16/userCertificate.css';
import i18n from '../I18N/I18n.js'; 
import { logout, apiPublicRequest, apiSecuredRequest, cambiarIdioma, checkFileType, setBearer} from '../functions.js';



class QRDPP16 extends Component {


    async componentDidMount() {
        await this.loadBrandFields();
        // 2. Carga de datos de la Blockchain
        await this.loadCertificate();

    }
    cambiarIdioma = (idioma) => {
        const { i18n } = this.props;
        i18n.changeLanguage(idioma);
        Cookies.set('idiomaPreferido', idioma, { expires: 365 }); // Cambia el idioma usando i18n
    };

    async loadBrandFields() {
        let data = JSON.stringify({
            "email": `${properties.appUser}`,
            "password": `${properties.appPass}`
        });


        const bearerToken = await apiPublicRequest('post', `${properties.apiUrl}/certificat/api/usuario/login`, data);
        let urlParams = (new URL(document.location)).searchParams;
        const certificadoId = urlParams.get("certificadoId");
        const idLinea = urlParams.get("idLinea");
        this.setState({idLinea})
        let camposData = JSON.stringify({
            "certificadoId": `${certificadoId}`,
            "tipoStandard": `DPP16`
        });
        const certificadoCompleto = await apiSecuredRequest('get', `${properties.apiUrl}/certificat/api/empresas/certificado/${certificadoId}`, "", bearerToken.data.accessToken);
        this.setState({certificadoCompleto: certificadoCompleto.data});

       

        const campos = await await apiSecuredRequest(
            'post', 
            `${properties.apiUrl}/certificat/api/campo/getCampos`, 
            camposData, 
            bearerToken.data.accessToken
        );


        
        

        this.setState({ campos: campos.data })
    }


    async loadCertificate() {

	
		let web3;
		
		let params = (new URL(document.location)).searchParams;
		const abi = standard_abiA
        
        const certificado = this.state.certificadoCompleto;
        const direccion = certificado.direccion;
        const direccion2 = certificado.direccion2;
        this.setState({direccion: direccion})
        this.setState({direccion2: direccion2})
		let ercIdVar;
		let nftSeleccionadoVar;

		if(abi && direccion && direccion2) {
			
			try{
				
		

					
					 web3 = new Web3(new Web3.providers.HttpProvider(properties.web3Provider));
					
           const contractA = new web3.eth.Contract(abi, direccion);
           const contractB = new web3.eth.Contract(abi, direccion2);
           this.setState({contractA});
           this.setState({contractB});
									 
                    
		   const idLinea = params.get("idLinea");
           const ownerCertificatesP2 = await contractA.methods.getOwnerStandardData(idLinea).call({ from: properties.proofUHostWallet });

                   
           const ownerCertificatesP2B = await contractB.methods.getOwnerStandardData(idLinea).call({ from: properties.proofUHostWallet });
                   

           //LOG IN
           nftSeleccionadoVar = {
            id: ownerCertificatesP2.id,
            idLinea: ownerCertificatesP2[0].idLinea,
            campo0: ownerCertificatesP2[0].campo0,
            campo1: ownerCertificatesP2[0].campo1,
            campo2: ownerCertificatesP2[0].campo2,
            campo3: ownerCertificatesP2[0].campo3,
            campo4: ownerCertificatesP2[0].campo4,
            campo5: ownerCertificatesP2[0].campo5,
            campo6: ownerCertificatesP2B[0].campo0,
            campo7: ownerCertificatesP2B[0].campo1,
            campo8: ownerCertificatesP2B[0].campo2,
            campo9: ownerCertificatesP2B[0].campo3,
            campo10: ownerCertificatesP2B[0].campo4,
            campo11: ownerCertificatesP2B[0].campo5
          };
           
           
           this.setState({ selectedNFT: nftSeleccionadoVar })

				


			}catch (err) {
				this.setState({ errorMessage: err })
			}
		}else{
			Swal.fire({
				title: `${i18n.t('certificatesError')}`,
				icon: 'error',
				showCancelButton: false,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "OK"
				}).then((result) => {
					if (result.isConfirmed) {
						window.locationbar.href = "/"
					}else  if(result.dismiss){
						window.locationbar.href = "/"
					}
				 
				})
			  window.locationbar.href = "/"
			

		}

		this.setState({loading: false});

	}

    constructor(props) {
        super(props)
        this.state = {
            account: null,
            showData: false,
            idLinea: null,
            certificadoCompleto: null,
            campos: null,
            selectedNFT: null
        }
    }

    render() {
        if ( this.state.selectedNFT != null) {
           
            return (
                <>
<Navbar mail={this.state.email} cambiarIdioma={this.cambiarIdioma} />

<div className="updated_menu_home_16">
 
  <div className="updated_content_info_16">
    <div className="updated_details_container_16">
     
      <div className="updated_certificate_data_card_16">
        <p className="updated_title_card_16"> <p className="product_model_16">{this.state.idLinea}</p></p>
        <table className="updated_product_details_table_16">
          <tr>
            <th className="updated_details_th_16">
              {this.state.campos.filter(campo => campo.orden == "CAMPO0")[0].nombreCampo}
            </th>
            <td className="updated_details_td_16">{this.state.selectedNFT.campo0}</td>
          </tr>
          <tr>
            <th className="updated_details_th_16">
              {this.state.campos.filter(campo => campo.orden == "CAMPO1")[0].nombreCampo}
            </th>
            <td className="updated_details_td_16">{this.state.selectedNFT.campo1}</td>
          </tr>
          <tr>
            <th className="updated_details_th_16">
              {this.state.campos.filter(campo => campo.orden == "CAMPO2")[0].nombreCampo}
            </th>
            <td className="updated_details_td_16">{this.state.selectedNFT.campo2}</td>
          </tr>
          <tr>
            <th className="updated_details_th_16">
              {this.state.campos.filter(campo => campo.orden == "CAMPO3")[0].nombreCampo}
            </th>
            <td className="updated_details_td_16">{this.state.selectedNFT.campo3}</td>
          </tr>
          <tr>
            <th className="updated_details_th_16">
              {this.state.campos.filter(campo => campo.orden == "CAMPO4")[0].nombreCampo}
            </th>
            <td className="updated_details_td_16">{this.state.selectedNFT.campo4}</td>
          </tr>
          <tr>
            <th className="updated_details_th_16">
              {this.state.campos.filter(campo => campo.orden == "CAMPO5")[0].nombreCampo}
            </th>
            <td className="updated_details_td_16">{this.state.selectedNFT.campo5}</td>
          </tr>
          <tr>
            <th className="updated_details_th_16">
              {this.state.campos.filter(campo => campo.orden == "CAMPO6")[0].nombreCampo}
            </th>
            <td className="updated_details_td_16">{this.state.selectedNFT.campo6}</td>
          </tr>
          <tr>
            <th className="updated_details_th_16">
              {this.state.campos.filter(campo => campo.orden == "CAMPO7")[0].nombreCampo}
            </th>
            <td className="updated_details_td_16">{this.state.selectedNFT.campo7}</td>
          </tr>
          <tr>
            <th className="updated_details_th_16">
              {this.state.campos.filter(campo => campo.orden == "CAMPO8")[0].nombreCampo}
            </th>
            <td className="updated_details_td_16">{this.state.selectedNFT.campo8}</td>
          </tr>
          <tr>
            <th className="updated_details_th_16">
              {this.state.campos.filter(campo => campo.orden == "CAMPO9")[0].nombreCampo}
            </th>
            <td className="updated_details_td_16">{this.state.selectedNFT.campo9}</td>
          </tr>
          <tr>
            <th className="updated_details_th_16">
              {this.state.campos.filter(campo => campo.orden == "CAMPO10")[0].nombreCampo}
            </th>
            <td className="updated_details_td_16">{this.state.selectedNFT.campo10}</td>
          </tr>
          <tr>
            <th className="updated_details_th_16">
              {this.state.campos.filter(campo => campo.orden == "CAMPO11")[0].nombreCampo}
            </th>
            <td className="updated_details_td_16">{this.state.selectedNFT.campo11}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>

<Footer />

                </>
            );

        } else {
            <h1>Loading</h1>
        }


    }
}

export default  withTranslation()(QRDPP16);
